import BreadCrumb from "../../../components/BreadCrumb";
import Button from "../../../components/Button";
import Layout from "../../../components/Layout";
import { Grid, useMediaQuery } from "@mui/material";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Table from "../../../components/Table/Table";
// import Badge from "../../../components/Badge";
import { TableSearch } from "../../../components/Table/TableActions";
import { ItemOption, ItemStatus } from "../../../utils/DropDown";
import useStyles from "../styles";
import { Icon } from "@iconify/react";
import Modal from "../../../components/Modal";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import InputGroup from "../../../components/FormComponent/InputGroup";
import { httprequest } from "../../../data/api";
import useValidator from "../../../hooks/useValidator";
import PageLoader from "../../../components/PageLoader";
// import PopModal from "../../../components/PopupModal/PopModal";

const SCHOOL_DISCOUNTS = "/api/v1/discounts";

const Discount = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const classes = useStyles();
  const [searchResult, setSearchResult] = useState([]);
  const [getLoading, setGetLoading] = useState(false);
  const [itemModal, setItemModal] = useState(false);
  const [edititemModal, setEditItemModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [itemLoading, setItemLoading] = useState(false);
  const [invoiceItem, setInvoiceItem] = useState([]);
  const [invoiceValidator, showInvoiceValidator] = useValidator();
  const [discountValidator, showDiscountValidator] = useValidator();
  const [discountLoading, setDiscountLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editinvoiceValidator, showEditInvoiceValidator] = useValidator();
  const [isDeleting, setIsItemDeleting] = useState(false);
  const [discountModal, setDiscountModal] = useState(false);
  const [customDiscount, setCustomDiscount] = useState(false);
  const [itemform, setItemForm] = useState({
    status: "",
    fee_option: "",
    item: ""
  });
  const [discountForm, setDiscountForm] = useState({});

  const handleDiscountModal = () => {
    setDiscountModal(!discountModal);
  };

  const handleCloseDiscountModal = () => {
    setDiscountForm({});
    setDiscountModal(false);
  };

  const handleCustomDiscount = () => {
    setCustomDiscount(!customDiscount);
  };

  /**
 * State hook for edit item form management.
 *
 */
  const [edititemform, setEditItemForm] = useState({
    name: "",
    start_date: "",
    end_date: "",
    description: "",
    value: ""
  });

  /**
 * Closes the edit modal and resets the edit form.
 * @function
 */

  const handleCloseEditModal = () => {
    setEditItemModal(false);
    setEditItemForm({
      ...edititemform,
      status: "",
      name: "",
      start_date: "",
      end_date: "",
      description: "",
      value: ""
    });
  };

  /**
 * Opens the edit modal and populates it with the selected row's data.
 * @function
 * @param {Object} row - The row data to edit.
 */
  const handleEditInvoiceItem = (row) => {
    setEditItemModal(!edititemModal);
    setCurrentRow(row);
    setEditItemForm({
      ...edititemform,
      name: row?.name,
      start_date: row?.start_date,
      description: row?.description,
      end_date: row?.end_date,
      value: row?.value
    });
  };

  /**
 * Closes the delete confirmation modal.
 * @function
 */
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  /**
 * Handles changes in the create item form inputs.
 * @function
 * @param {Object} e - The event object from the input element.
 */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setItemForm({ ...itemform, [name]: value });
  };
  /**
 * Handles changes in the create item form inputs.
 * @function
 * @param {Object} e - The event object from the input element.
 */
  const handleDiscountChange = (e) => {
    const { name, value } = e.target;
    setDiscountForm({ ...discountForm, [name]: value });
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";

    return new Date(dateString).toISOString().split("T")[0];
  };

  /**
 * Handles changes in the edit item form inputs.
 * @function
 * @param {Object} e - The event object from the input element.
 */
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditItemForm({ ...edititemform, [name]: value });
  };

  /**
 * Toggles the create item modal visibility.
 * @function
 */
  const handleOpenItemMOdal = () => {
    setItemModal(!itemModal);
  };

  /**
 * Opens the delete confirmation modal for a specific item.
 * @function
 * @param {Object} row - The row data to potentially delete.
 */
  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };
  /**
 * Fetches all invoice items from the server.
 * @function
 * @description Makes a GET request to SCHOOL_DISCOUNTS endpoint and updates the invoice items state.
 */
  const getAllDiscounts = () => {
    setGetLoading(true);
    httprequest
      .get(SCHOOL_DISCOUNTS)
      .then((res) => {
        setInvoiceItem(res?.data?.data);
        setSearchResult(res?.data?.data);
        setGetLoading(false);
      }).catch((err) => {
        setGetLoading(true);
        toast.error(err?.response?.data?.message);
      });
  };

  /**
 * Handles creation of a new invoice item.
 * @function
 * @description Validates the form, makes a POST request to SCHOOL_DISCOUNTS endpoint,
 * and handles the response or error.
 */
  const handleCreateItem = () => {
    if (invoiceValidator.allValid()) {
      setItemLoading(true);
      httprequest
        .post(SCHOOL_DISCOUNTS, itemform)
        .then((res) => {
          setItemLoading(false);
          toast.success(res?.data?.message || "Item created successfully");
          handleOpenItemMOdal();
          getAllDiscounts();
        })
        .catch((err) => {
          setItemLoading(false);
          toast.error(err?.response?.data);
        });
    } else {
      showInvoiceValidator(true);
    }
  };
  /**
 * Handles creation of a new invoice item.
 * @function
 * @description Validates the form, makes a POST request to SCHOOL_DISCOUNTS endpoint,
 * and handles the response or error.
 */
  const handleCreateDiscount = () => {
    if (discountValidator.allValid()) {
      setDiscountLoading(true);
      httprequest
        .post(SCHOOL_DISCOUNTS, discountForm)
        .then((res) => {
          setDiscountLoading(false);
          toast.success(res?.data?.message);
          handleCloseDiscountModal();
          getAllDiscounts();
        })
        .catch((err) => {
          setDiscountLoading(false);
          toast.error(err?.response?.data);
        });
    } else {
      showDiscountValidator(true);
    }
  };

  /**
 * Handles editing of an existing invoice item.
 * @function
 * @description Validates the form, makes a PATCH request to update the item,
 * and handles the response or error.
 */
  const handleEditItem = () => {
    if (editinvoiceValidator.allValid()) {
      setItemLoading(true);
      httprequest
        .patch(`${SCHOOL_DISCOUNTS}/${currentRow?.id}`, edititemform)
        .then((res) => {
          setItemLoading(false);
          toast.success(res?.data?.message || "Item created successfully");
          getAllDiscounts();
          handleCloseEditModal();
        })
        .catch((err) => {
          setItemLoading(false);
          toast.error(err?.response?.data);
        });
    } else {
      showEditInvoiceValidator(true);
    }
  };

  /**
 * Handles deletion of an invoice item.
 * @function
 * @description Makes a DELETE request to remove the item and handles the response or error.
 */
  const handleDeleteItem = () => {
    setIsItemDeleting(true);
    httprequest.delete(`${SCHOOL_DISCOUNTS}/${currentRow?.id}`).then((res) => {
      setIsItemDeleting(false);
      toast.success(res?.data?.message);
      getAllDiscounts();
      handleCloseDeleteModal();
    }).catch((err) => {
      setIsItemDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
 * Column definitions for the invoice items data table.
 * @type {Array<Object>}
 * @property {string} name - The column header name.
 * @property {Function} selector - Function to render cell content.
 * @property {boolean} [center] - Whether to center the column content.
 * @property {Function} [cell] - Alternative render function for cells.
 * @property {boolean} [sortable] - Whether the column is sortable.
 */
  const columns = [
    {
      name: "Name",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Name</p>}
          {row?.name || "--/--"}
        </>
      )
    },
    {
      name: "Value",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Value</p>}
          {row?.value || "--/--"}
        </>
      )
    },
    {
      name: "Start Date",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Start Date</p>}
          {row?.start_date?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "End Date",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">End Date</p>}
          {row?.end_date?.substring(0, 10) || "--/--"}
        </>
      )
    },
    // {
    //   name: "Status",
    //   center: "true",
    //   cell: (row) => (
    //     <p style={{ display: "flex", flexDirection: "column", margin: 0, marginBlock: 0 }}>
    //       {isMobile && <p style={{ margin: 0, fontSize: "12px" }}>Status</p>}
    //       <Badge status={row?.status} />
    //     </p>
    //   )
    // },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button
            className="table-action-icon"
            onClick={() => handleEditInvoiceItem(row)}
          >
            <Icon icon="lucide:edit" />
          </button>
          <button
            className="table-action-icon delete-icon"
            onClick={() => handleDeleteModal(row)}
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  /**
 * Handles search functionality for invoice items.
 * @function
 * @param {Object} e - The event object from the search input.
 * @description Filters invoice items based on search terms matching status, fee_option, item, or payment_method.
 */
  const handleSearchStudent = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = invoiceItem?.filter((data) => valArray?.every(
      (word) => data?.status
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                              data?.fee_option
                                ?.toLowerCase()
                                .includes(word.toLowerCase()) ||
                              data?.item
                                ?.toLowerCase()
                                .includes(word.toLowerCase()) ||
                                data?.payment_method
                                  ?.toLowerCase()
                                  .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  useEffect(() => {
    getAllDiscounts();
  }, []);

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb link_one="/payment/overview" link_one_name="Payments" active="Discount" description="See all discounts" />
          </div>
          <div className="flex gap-10">
            {/* <Button
              variant="primaryoutline"
              buttonSize="medium"
              color="btnfontprimary"
              buttonName="Custom Discount"
              onClick={handleCustomDiscount}
            /> */}
            <Button
              onClick={handleDiscountModal}
              variant="primary"
              buttonSize="medium"
              color="btndefault"
              buttonName="Create Discount"
            />
          </div>
        </div>
        <div className="page-content margin-top-30">
          <>
            {getLoading ? (
              <PageLoader />
            ) : (
              <Table
                data={searchResult}
                columns={columns}
                subHeader={true}
                pagination
                subHeaderComponent={
                  <div className="action_div">
                    <TableSearch
                      placeholder="Search here..."
                      searchTableFunc={handleSearchStudent}
                    />
                  </div>}
              />
            )}
          </>
        </div>
        {/* Add Option */}
        <Modal
          title="Create Invoice Item"
          subtitle={
            <div>
                Create an item to be used in your invoices.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Item Name"
                    margin="normal"
                    inputType="text"
                    required
                    inputName="item"
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Item Option"
                    required
                    children={
                      <select name="fee_option" onChange={handleChange}>
                        <option value="">--- Select ---</option>
                        {ItemOption?.map((itemoptions) => {
                          return (
                            <option key={itemoptions.key} value={itemoptions?.key}>
                              {itemoptions?.text}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Status"
                    required
                    children={
                      <select name="status" onChange={handleChange}>
                        <option value="">--- Select ---</option>
                        {ItemStatus?.map((status) => {
                          return (
                            <option key={status?.key} value={status?.key}>
                              {status?.text}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primaryoutline"
                  buttonSize="full"
                  color="btnfontprimary"
                  buttonName="Cancel"
                //   onClick={handlePostStudentResult}
                //   isLoading={resultCreating}
                />
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Save"
                  onClick={handleCreateItem}
                  isLoading={itemLoading}
                />
              </div>
            </>
          }
          isopen={itemModal}
          closeModal={handleOpenItemMOdal}
        />
        {/* Add Option */}
        <Modal
          title="Edit Discount"
          subtitle={
            <div>
                Edit a disount
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Discount Name"
                    margin="normal"
                    inputType="text"
                    inputName="name"
                    required
                    defaultValue={edititemform?.name}
                    onChange={handleEditChange}
                  />
                  {editinvoiceValidator.message("Name", edititemform?.name, "required")}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Start Date"
                    margin="normal"
                    inputType="date"
                    inputName="start_date"
                    // required
                    defaultValue={formatDateForInput(edititemform?.start_date)}
                    onChange={handleEditChange}
                  />
                  {/* {editinvoiceValidator.message("Start Date", edititemform?.start_date, "required")} */}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="End Date"
                    margin="normal"
                    inputType="date"
                    inputName="end_date"
                    // required
                    defaultValue={formatDateForInput(edititemform?.end_date)}
                    onChange={handleEditChange}
                  />
                  {/* {editinvoiceValidator.message("End Date", edititemform?.end_date, "required")} */}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Description"
                    margin="normal"
                    inputType="text"
                    inputName="end_date"
                    // required
                    defaultValue={edititemform?.description}
                    onChange={handleEditChange}
                  />
                  {/* {editinvoiceValidator.message("Description", edititemform?.description, "required")} */}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Discount Value"
                    margin="normal"
                    inputType="text"
                    inputName="value"
                    required
                    defaultValue={edititemform?.value}
                    onChange={handleEditChange}
                  />
                  {editinvoiceValidator.message("Value", edititemform?.value, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primaryoutline"
                  buttonSize="full"
                  color="btnfontprimary"
                  buttonName="Cancel"
                  onClick={handleCloseEditModal}
                //   isLoading={resultCreating}
                />
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Edit Discount"
                  onClick={handleEditItem}
                  isLoading={itemLoading}
                />
              </div>
            </>
          }
          isopen={edititemModal}
          closeModal={handleCloseEditModal}
        />
        <Modal
          title="Create Discount"
          subtitle={
            <div>
                 Create discount for your student
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Discount Name"
                    margin="normal"
                    inputType="text"
                    inputName="name"
                    required
                    onChange={handleDiscountChange}
                  />
                  {discountValidator.message("Discount Name", discountForm?.name, "required")}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Start Date"
                    margin="normal"
                    inputType="date"
                    inputName="start_date"
                    // inputMin={formattedToday}
                    required
                    onChange={handleDiscountChange}
                  />
                  {discountValidator.message("Start Date", discountForm?.start_date, "required")}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="End Date"
                    margin="normal"
                    inputType="date"
                    inputName="end_date"
                    // inputMin={formattedToday}
                    onChange={handleDiscountChange}
                    // required
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Discount Description"
                    margin="normal"
                    inputType="text"
                    inputName="description"
                    // inputMin={formattedToday}
                    onChange={handleDiscountChange}
                    // required
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Discount Percentage"
                    margin="normal"
                    inputType="text"
                    inputName="value"
                    // inputMin={formattedToday}
                    onChange={handleDiscountChange}
                    required
                  />
                  {discountValidator.message("Discount Value", discountForm?.value, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <label className={classes.quelabel}>Reason <span className="input-required"></span></label>
                  <div className={classes.textandimg}>
                    <textarea
                      type="text"
                      placeholder="Input reason"
                      name="description"
                      onChange={handleDiscountChange}
                    />
                  </div>
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <Button
                variant="primary"
                buttonName="Apply"
                buttonSize="full"
                color="btndefault"
                onClick={handleCreateDiscount}
                isLoading={discountLoading}
              />
            </>
          }
          isopen={discountModal}
          closeModal={handleCloseDiscountModal}
        />
        <Modal
          title="Create Custom Discount"
          subtitle={
            <div>
                Create custom discount for your students
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Discount Name"
                    margin="normal"
                    inputType="text"
                    inputName="due_date"
                    required
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Validity Period"
                    margin="normal"
                    inputType="date"
                    inputName="due_date"
                    // inputMin={formattedToday}
                    required
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Discount Description"
                    margin="normal"
                    inputType="text"
                    inputName="due_date"
                    // inputMin={formattedToday}
                    required
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Discount Value"
                    margin="normal"
                    inputType="text"
                    inputName="due_date"
                    // inputMin={formattedToday}
                    required
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <label className={classes.quelabel}>Reason <span className="input-required"> *</span></label>
                  <div className={classes.textandimg}>
                    <textarea
                      type="text"
                      placeholder="Input reason"
                      name="description"
                      onChange={handleChange}
                    />
                  </div>
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <Button
                variant="primary"
                buttonName="Apply"
                buttonSize="full"
                color="btndefault"
                // onClick={handleCreateNotice}
                // isLoading={isLoading}
              />
            </>
          }
          isopen={customDiscount}
          closeModal={handleCustomDiscount}
        />
        {/* Delete Modal */}
        <Modal
          title="Delete Item"
          subtitle={
            <div>Are you sure you want to delete <span className="modal-name-highlight">{currentRow?.name}</span>. Implication is that discount will be permanently erased.
            </div>}
          modalContent={
            <>

            </>
          }
          modalFooter={
            <>
              <Button variant="danger" buttonName="Delete Item" buttonSize="full" color="btndefault" onClick={handleDeleteItem} isLoading={isDeleting} />
            </>
          }
          isopen={deleteModal}
          closeModal={handleCloseDeleteModal}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default Discount;
